import Entities from 'STORE';

export async function outViewMessage(groupId: string, messageId: string): Promise<void> {
  Entities.viewportMessages.removeViewportMessage(groupId, messageId);
}
